@import (reference) '../../constants/spacing.module.less';

.body {
  padding: @space-16;
}

.header {
  display: flex;
  align-items: center;
}

.footer {
  align-items: center;
  display: flex;
  gap: @space-8;
  justify-content: flex-end;
}

.footer > button:nth-child(2) {
  p {
    font-weight: 600;
  }
}
